var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirportTransferFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.09 13.4196C18.0009 13.1651 17.7591 12.9996 17.4727 12.9996H12.8973C12.6045 12.9996 12.3691 13.1651 12.2736 13.4196L11.3636 16.0352V19.5418C11.3636 19.7836 11.5673 20 11.8091 20H12.2036C12.4455 20 12.6364 19.7582 12.6364 19.5163V18.7272H17.7273V19.5163C17.7273 19.7582 17.9245 20 18.1664 20H18.5545C18.7964 20 19 19.7836 19 19.5418V16.0352L18.09 13.4196ZM12.8973 13.636H17.4727L18.1282 15.5452H12.2418L12.8973 13.636ZM12.6364 17.4544C12.2864 17.4544 12 17.168 12 16.818C12 16.468 12.2864 16.1816 12.6364 16.1816C12.9864 16.1816 13.2727 16.468 13.2727 16.818C13.2727 17.168 12.9864 17.4544 12.6364 17.4544ZM17.7273 17.4544C17.3773 17.4544 17.0909 17.168 17.0909 16.818C17.0909 16.468 17.3773 16.1816 17.7273 16.1816C18.0773 16.1816 18.3636 16.468 18.3636 16.818C18.3636 17.168 18.0773 17.4544 17.7273 17.4544ZM8.60182 14.6097L8.81818 16.1816L8.15 16.8562L7.03 14.8324L5 13.706L5.67455 13.0187L7.26545 13.2542L9.72818 10.7913L5 8.30297L5.90364 7.40565L11.7518 8.75482L14.2273 6.27922C14.5836 5.90693 15.22 5.90693 15.5764 6.27922C15.9518 6.6547 15.9518 7.272 15.5764 7.62839L13.1009 10.104L13.6227 12.3632H12.8973C12.3436 12.3632 11.8664 12.6814 11.6818 13.1969L11.6627 13.2351L11.0836 12.1277L8.60182 14.6097Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirportTransferFilled);
export default __webpack_public_path__ + "static/media/airport-transfer-filled.4598cc1ff2574d9b6f2cc6050113c80e.svg";
export { ForwardRef as ReactComponent };